import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTelegram } from '../hooks/useTelegram';

interface CTAButtonProps {
  label?: string;
  to?: string;
  onClick?: () => void;
  floating?: boolean;
}

const CTAButton: React.FC<CTAButtonProps> = ({
  label = 'Обсудить проект',
  to = '/order',
  onClick,
  floating = false,
}) => {
  const navigate = useNavigate();
  const { hapticImpact } = useTelegram();

  const handleClick = () => {
    hapticImpact('medium');
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  const arrowIcon = (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );

  if (floating) {
    return (
      <motion.div
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.68, ease: [0, 0, 0.25, 1] }}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'center',
          padding: '12px 24px calc(12px + env(safe-area-inset-bottom, 0px))',
          zIndex: 100,
          pointerEvents: 'none',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(245,245,244,0.95) 50%, transparent)',
            pointerEvents: 'none',
          }}
        />
        <button
          onClick={handleClick}
          style={{
            position: 'relative',
            width: '100%',
            maxWidth: '432px',
            padding: '16px',
            borderRadius: '14px',
            border: 'none',
            background: '#1D1D1F',
            color: '#FEFEFE',
            fontFamily: "'Instrument Sans', -apple-system, sans-serif",
            fontSize: '15px',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            cursor: 'pointer',
            WebkitTapHighlightColor: 'transparent',
          }}
        >
          {label}
          {arrowIcon}
        </button>
      </motion.div>
    );
  }

  return (
    <button
      onClick={handleClick}
      style={{
        width: '100%',
        padding: '16px',
        borderRadius: '14px',
        border: 'none',
        background: '#1D1D1F',
        color: '#FEFEFE',
        fontFamily: "'Instrument Sans', -apple-system, sans-serif",
        fontSize: '15px',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
      }}
    >
      {label}
      {arrowIcon}
    </button>
  );
};

export default CTAButton;
